// extracted by mini-css-extract-plugin
export default {"content":"TabRelacionesComponet_content__uOKCu","nav":"TabRelacionesComponet_nav__tM0Vg","a":"TabRelacionesComponet_a__yiZHS","a1":"TabRelacionesComponet_a1__JuZGX"};